import { app } from '../../app.module'
app
  // 投稿タグ管理モーダルを表示するためのボタン
  .directive('editBrandButton', () => {
    return {
      restrict: 'E',
      template: require('./edit-brand-button.pug')(),
      controller: function ($rootScope, $scope, $mdDialog, $attrs) {
        // ボタン表示判定用にタイプをセット
        $scope.type = $attrs.type

        // タグボタンをクリックした際の処理
        $scope.showModal = function () {
          // モーダル用のスコープを新規に作成し、モーダル内で使用するパラメーターを格納
          const modalScope: {
            type: string
            brandData: {
              brandId: number
            }
            isInput: boolean
          } = $rootScope.$new()

          // ブランドID
          modalScope.brandData = {
            brandId: $attrs.brandId,
          }

          // 種別(new or edit)
          modalScope.type = $attrs.type

          // 新規作成場合, 新規モーダルを表示にする
          if ($attrs.type === 'new') {
            modalScope.isInput = true
          } else if ($attrs.type === 'edit') {
            // 編集モーダルを非表示にする
            modalScope.isInput = false
          }

          // モーダルを表示する
          $mdDialog.show({
            template: require('./edit-brand-modal.pug')(),
            scope: modalScope,
            clickOutsideToClose: true,
          })
        }
      },
    }
  })
